import { Routes, Route, Navigate } from "react-router-dom";
import "./styles/index.css";
import Header from "./components/Header/Header.js";
import MatchStatus from "./pages/MatchStatus/MatchStatus.js";
import MatchResults from "./pages/MatchResults/MatchResults.js";
import { FilterProvider } from "./components/Filter/FilterContext.js";
import { YearProvider } from "./context/YearContext.js";
import Targets from "./pages/GroupFormation/Targets";
import { TopRank } from "./TopRank.js";
import "./locales/i18n.js";

function App() {
  return (
    <YearProvider>
      <FilterProvider>
        <div className="App">
          <Routes>
            <Route path="top-rank" element={<TopRank />} />
            <Route
              path="*"
              element={
                <div className="system">
                  <Header />
                  <div className="contents">
                    <Routes>
                      <Route
                        path="/"
                        element={<Navigate to="/match-status/participants" replace />}
                      />
                      <Route path="top-rank" element={<TopRank />} />
                      <Route path="match-status/*" element={<MatchStatus />} />
                      <Route path="group-formation/*" element={<Targets />} />
                      <Route path="match-results/*" element={<MatchResults />} />
                    </Routes>
                  </div>
                  <div className="system-bg"></div>
                </div>
              }
            />
          </Routes>
        </div>
      </FilterProvider>
    </YearProvider>
  );
}
export default App;
